/**
 * Qué renglones de un presupuesto se llevan al turno y al remito.
 * Espejo de `server/utils/budgetItems.js` — si cambia uno, cambia el otro.
 *
 * Dos filtros acumulativos:
 *  - la opción elegida: la base va siempre, y de las alternativas solo la
 *    seleccionada (las opciones no son acumulativas entre sí);
 *  - los renglones rechazados: el cliente aprobó pero sacó algo. No se borran
 *    —queda registrado qué rechazó— pero no se cobran ni se trabajan.
 */

/** El backend puede devolver el booleano como 1/0, 't'/'f' o true/false. */
export const esRechazado = (item: any): boolean => {
  const v = item?.rejected;
  return v === true || v === 1 || v === '1' || v === 't' || v === 'true';
};

export function itemsAprobados<T>(
  items: T[] | null | undefined,
  selectedOption?: string | number | null
): T[] {
  const opcion = selectedOption == null ? null : String(selectedOption);
  return (items || []).filter((it: any) => {
    if (!it || esRechazado(it)) return false;
    if (!it.optionCode) return true;
    return opcion !== null && String(it.optionCode) === opcion;
  });
}
